import {randomFromArray} from '../../../helpers/random-from-array.js'
import {getRandomInRange} from '../../../helpers/numbers-helper.js'

export function getBuggingChanges(action, combatantMap, currentCombatantStateChanges, combatantModels) {

    //Set up for modification
    let changes = {
        ...currentCombatantStateChanges
    };

    if (action.sabotageItemQuantity === 1) {
        //Find the targets that have non-bugged items
        const targetModelsWithItems = combatantMap.targetIds.map(combId => {
            return combatantModels[combId]; //get model
        }).filter(combModel => {
            //Only include targets that have Buggable items that have not been Bugged yet
            const nonBuggedItems = (combModel.items || []).filter(item => {
                return !item.isBugged
            });
            return nonBuggedItems.length;
        });

        const singleTarget = randomFromArray(targetModelsWithItems); //Take one enemy that has items
        const indexToBug = getRandomInRange(0, singleTarget.items.length-1);


        //Create a new version of items for this singleCombatant that includes the isBugged flag on chosen index
        const updatedSingleTargetItems = singleTarget.items.map((item, index) => {
            if (index === indexToBug) {
                return {
                    ...item,
                    isBugged: true
                }
            }
            return item;
        });

        changes.state[singleTarget.id].items = [...updatedSingleTargetItems];

      //For Reporting:
      changes.description["buggedItems"] = [
        {...updatedSingleTargetItems[indexToBug]}
        //Can only bug one item right now. In the future, include any of them that may have been bugged!
      ];
    }

    return changes;
}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/description/bugging.js